import React from 'react';
import { 
    Box, 
    Typography, 
    FormControlLabel, 
    Checkbox,
    Paper
} from '@mui/material';
import { BreakdownData } from '../../Types/InspectionTypes';

interface BreakdownSectionProps {
    breakdown: BreakdownData;
    onUpdate: (field: keyof BreakdownData, value: boolean) => void;
    isMobile?: boolean;
}

const BreakdownSection: React.FC<BreakdownSectionProps> = ({ breakdown, onUpdate, isMobile = false }) => {
    return (
        <Paper 
            elevation={0} 
            sx={{ 
                p: isMobile ? 1.5 : 2, 
                mb: isMobile ? 1.5 : 2, 
                backgroundColor: 'action.hover',
                border: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Typography 
                variant={isMobile ? "caption" : "subtitle2"} 
                sx={{ mb: 1, fontWeight: 600, color: 'text.primary' }}
            >
                Breakdown
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: isMobile ? 0.5 : 1 }}>
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={breakdown.sporadic}
                            onChange={(e) => onUpdate('sporadic', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Sporadic</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={breakdown.mild}
                            onChange={(e) => onUpdate('mild', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Mild</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={breakdown.moderate}
                            onChange={(e) => onUpdate('moderate', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Moderate</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={breakdown.heavy}
                            onChange={(e) => onUpdate('heavy', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Heavy</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={breakdown.hotSpot}
                            onChange={(e) => onUpdate('hotSpot', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Hot Spot</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
            </Box>
        </Paper>
    );
};

export default BreakdownSection;
